import React, { Component } from 'react';
import { connect } from "react-redux";
import AlertContainer from 'react-alert'
import DF from 'dateformat';
import ReactPixel from 'react-facebook-pixel';

import FbWrapper from '../../lib/FirebaseWrapper';
import SupportedCriteria from './assets/SupportedCriteria.json';
import Picker from './components/Picker';
import Header from './components/Header';
import Result from './components/sidebar/Result';

import './index.css';
import './components/basic/masterUI.css';

const MAX_FILTER_CRITERIA_COUNT = 5;

class PickerView extends Component {
  constructor() {
    super();
    this.state = {
      criteria: SupportedCriteria,
      selectedResultCriterionLabel: '',
      isFilterCriterionClicked: false,
      currentStep: 1,
      filterCriteria: new Set(),
      sortCriteria: new Set(),
      sortType: null,

      // trading Preferences
      tradingPreference: {
        startDate: '2015-01-01',
        endDate: '2017-01-01',
        rebalanceFrequency: null,
        stockCount: 25,
      },
    }
  }

  alertOptions = {
    offset: 14,
    position: 'bottom left',
    theme: 'light',
    time: 5000,
    transition: 'scale'
  }

  stepSelected = (stepID) =>
    this.setState({currentStep: stepID});

  getCategoryAll = () => {
    let allCriteriaList = [];
    for (let category of this.state.criteria) {
      for (let criterion of category.list) {
        allCriteriaList.push(criterion);
      }
    }
    allCriteriaList.sort((a,b) =>  a.label.localeCompare(b.label));
    return allCriteriaList;
  };

  resetResultCriterionClicked = () => {
    this.setState({isFilterCriterionClicked: false})
  }

  updateSelectedResultCriterionLabelHandler = (label, step) => {
    this.setState({
      currentStep: step,
      isFilterCriterionClicked: true,
      selectedResultCriterionLabel: label,
    });
  }

  resultValueOnUpdate = (type, value) => {
    switch (type) {
      case 'sortType':
        this.setState({ sortType: value });
        break;
      case 'startDate':
      case 'endDate':
      case "rebalanceFrequency":
      case "stockCount":
        var newState = Object.assign({}, this.state.tradingPreference);
        newState[type] = value;
        this.setState({ tradingPreference: newState });
    }
  }

  _selectedCriteriaData = () => {
    return {
      1: this.state.filterCriteria,
      2: this.state.sortCriteria,
      3: this.state.tradingPreference,
    };
  }

  _selectedCriteria = () => {
    switch (this.state.currentStep) {
      case 1:
        return this.state.filterCriteria;
      case 2:
        return this.state.sortCriteria;
      case 3:
      default:
        return new Set();
    }
  }

  _updateSelectedCriteria = (criterion, step=this.state.currentStep) => {
    switch (step) {
      case 1:
        let filterCriteria = new Set(this.state.filterCriteria);
        if (filterCriteria.has(criterion)) {
          filterCriteria.delete(criterion)
        } else {
          if (filterCriteria.size >= MAX_FILTER_CRITERIA_COUNT) {
            this.msg.show("Reached max number of Filtering Criteria of 5!", {
              time: 2000,
              type: 'warning',
              icon: <img src="http://i.imgur.com/C7RBc0g.png" alt="error" style={{width:32, height:32}} />
            });
            break;
          }
          filterCriteria.add(criterion);
        }
        this.setState({ filterCriteria });
        break;
      case 2:
        let sortCriteria = new Set();
        var sortType = null;
        if (this.state.sortCriteria.has(criterion)) {
          sortType = (' ' + this.state.sortType).slice(1);
        } else {
          sortCriteria.add(criterion);
        }
        this.setState({ sortCriteria, sortType });
        break;
      case 3:
      default:
    }
  }

  _updateSelectedCriterionAttribute = (type, criterion, step, value) => {
    let newData = Object.assign({}, this._selectedCriteriaData());
    let oldSet = newData[step];
    let newSet = new Set();
    oldSet.forEach(e => {
      if (e === criterion) {
        switch(type) {
          case "max":
            e.max = value;
            break;
          case "min":
            e.min = value;
            break;
          default:
            console.error("unknow `updateSelectedCriterionSpec` type");
        }
      }
      newSet.add(e);
    });
    newData[step] = newSet;
    this.setState({
      filterCriteria: newData[1],
      sortCriteria: newData[2],
    });
  }

  _processRawDate(date) {
    return date.toString().replace('-', '').replace('-', '');
  }

  _handleDataSubmission = () => {
    // validate data
    var errors = [];
    const data = this._selectedCriteriaData();
    // Step 1
    if (data[1].size < 1) errors.push("Step #1 - Missing value");
    // Step 2
    if (data[2].size < 1) errors.push("Step #2 - Missing value");
    if (!this.state.sortType) errors.push("Step #2 - Missing sort type");
    // Step 3
    if (!this.state.tradingPreference.rebalanceFrequency) {
      errors.push("Step #3 - Missing rebalance frequency");
    }

    if (errors.length > 0) {
      errors.forEach(e => {
        this.msg.show(e, {
          time: 2000,
          type: 'error',
          icon: <img src="http://i.imgur.com/C7RBc0g.png" alt="error" style={{width:32, height:32}} />
        });
      });
      return;
    }

    // prepare submission data
    const typesAndValues = this._prepareSelectedTypesAndValues();
    const message = {
      email: this.props.authUser.email,

      // step #1 logic
      selectedTypes: typesAndValues.types,
      selectedValues: typesAndValues.values,

      // step #2
      sortBy: this.state.sortCriteria.values().next().value.value,
      sortOrder: this.state.sortType,

      // step #3
      startDate: this._processRawDate(this.state.tradingPreference.startDate),
      endDate: this._processRawDate(this.state.tradingPreference.endDate),
      rebalanceFrequency: this.state.tradingPreference.rebalanceFrequency,
      numberOfStocks: this.state.tradingPreference.stockCount,
    };

    // TODO: support email subscription
    const subscribed = this.state.subscribed || false;
    console.log("message", message, "subscribed", subscribed);
    ReactPixel.trackCustom("initiateBacktest", {});

    // submit and push to confirmation view
    var submissionKey = FbWrapper.submitResponse(
      message,
      message.email,
      subscribed
    );
    var path = '/submission/' + submissionKey;
    if (!!message.email) path += '/email/' + message.email;
    this.props.history.push(path);
  }

  _prepareSelectedTypesAndValues() {
    var types = [];
    var values = [];
    this.state.filterCriteria.forEach(e => {
      types.push(e);
      values.push({value: {
        largeValue: e.max,
        smallValue: e.min
      }});
    });

    return { types, values };
  }

  render() {
    let categories = [{name: "All", list: this.getCategoryAll()}, ...this.state.criteria];

    return (
      <div className="PickerView">
        <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />

        <Result
          history={this.props.history}
          updateAttribute={this._updateSelectedCriterionAttribute}
          currentStep={this.state.currentStep}
          stepSelected={this.stepSelected}
          remove={this._updateSelectedCriteria}
          clicked={this.updateSelectedResultCriterionLabelHandler}
          valueOnUpdate={this.resultValueOnUpdate}
          sortType={this.state.sortType}
          onSubmit={this._handleDataSubmission}
          criteriaData={this._selectedCriteriaData()}
        />
        <Header currentStep={this.state.currentStep}></Header>
        <div className="AS-config">
          <Picker
            selectedResultCriterionLabel={this.state.selectedResultCriterionLabel}
            isFilterCriterionClicked={this.state.isFilterCriterionClicked}
            selectedResultCriterionDisplayed={this.resetResultCriterionClicked}
            clicked={this._updateSelectedCriteria}
            categories={categories}
            currentStep={this.state.currentStep}
            selectedCriteria={this._selectedCriteria()}>
          </Picker>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authUser: state.sessionState.authUser
})

export default connect(mapStateToProps)(PickerView);



// WEBPACK FOOTER //
// ./src/views/PickerView/index.js